export default "__VITE_ASSET__Ko_yODVe__"